import { $ } from '@/libs/jquery/index'

const presetOptions = {
  autoClose: true,
  firstDay: 1,
  format: 'dd-mm-yyyy',
  i18n: {
    cancel: 'Закрыть',
    clear: 'Сбросить',
    months: [
      'Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август',
      'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь',
    ],
    monthsShort: ['Янв', 'Фев', 'Март', 'Апр', 'Май', 'Июнь', 'Июль', 'Авг', 'Сент', 'Окт', 'Нояб', 'Дек'],
    weekdays: ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'],
    weekdaysAbbrev: ['В', 'П', 'В', 'С', 'Ч', 'П', 'С'],
    weekdaysShort: ['Вск', 'Пон', 'Втр', 'Срд', 'Чтв', 'Птн', 'Суб'],
  },
  showClearBtn: true,
  yearRange: 75, // Number of years either side
}

enum maxDateFormat {
  Today = 'today',
}

const setMaxDate = (val: string): Date => {
  // val === maxDateFormat.Today ?
  // нужно поставить условие, если появятся другие maxDate
  return new Date()
}

export class DatePickerLib {
  public static attachDatePicker(element: HTMLElement): void {
    const $element = $(element)

    const settings = (element.dataset && element.dataset.maxDate)
      ? {...presetOptions, maxDate: setMaxDate(element.dataset.maxDate)}
      : presetOptions

    $element.datepicker({...settings})

    //  Датапикеры очень плохо умеют нормально в материалайз (хотя являются их ядром)
    //  Делаем хак для того что бы они нормально отображались (при клике в родителя)
    $element.parent().each((index, elem) => {
      $(elem).on('click', (e) => {
        const target = $(e.target)

        if (!target.is('.datepicker')) {
          const picker = target.children('.datepicker')

          if (picker.length) {
            picker.trigger(e.type)
            e.preventDefault()
            e.stopPropagation()

            return false
          }
        }
      })
    })
  }
}
